module.exports = __webpack_public_path__ + "img/add-photo-fourth-icon.4c367688.svg";